let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7kiNM"), load("5MjBi"), load("2F69B"), load("kOWvR"), load("4D7T2")]).then(() => parcelRequire('1x5LM'));